import axios from "axios";

export default axios.create({
  baseURL: "https://homolog.monosindico.monosoft.com.br/api",
});
